import { observer } from 'mobx-react-lite'
import { Dropdown, DropdownItem } from '@/components/Dropdown'
import { IconButton } from '@/components/IconButton'
import { type DocumentViewModel } from '@/features/docs/DocumentViewModel'
import type { DocumentAccess } from '@/features/docs/DocumentAccess'

export interface DocumentActionsDropdownContainerProps {
  vm?: DocumentViewModel
  /**
   * If specified, will show the unlink dialog when the user clicks the
   * remove dropdown item. Otherwise, will show the delete dialog.
   */
  access?: DocumentAccess
}

/**
 * Container for document actions.
 */
export const DocumentActionsDropdownContainer = observer(
  function DocumentActionsDropdownContainer({
    vm,
    access,
  }: DocumentActionsDropdownContainerProps) {
    return (
      <Dropdown
        title="More"
        trigger={<IconButton name="more" isSkeleton={!vm} label="Actions" />}
      >
        <DropdownItem icon="view" onAction={vm?.preview}>
          Preview
        </DropdownItem>
        <DropdownItem icon="download" onAction={vm?.download}>
          Download
        </DropdownItem>
        <DropdownItem icon="edit-name" onAction={vm?.rename}>
          Rename
        </DropdownItem>
        {access ? (
          <DropdownItem icon="remove" onAction={() => vm?.remove(access)}>
            Remove
          </DropdownItem>
        ) : (
          <DropdownItem icon="delete" onAction={vm?.delete}>
            Delete
          </DropdownItem>
        )}
      </Dropdown>
    )
  },
)
